
<div class="wrapper-lister-home">
  <img *ngIf="lister.profile_photo_url === null" class="img-lister"
       [src]="(lister.subscriptions | checkActiveRole) === UserRoles.expert ? '../../../../../assets/images/avatar-user-expert.png' : '../../../../../assets/images/avatar-user.png'" alt="">
  <img *ngIf="lister.profile_photo_url !== null" [src]="lister.profile_photo_url" alt="">
  <span class="name">{{lister.name}}</span>
  <span class="followers">{{lister.followers_count}} {{lister.followers_count === 1 ? ('GENERAL.followers'  | translate) : ('GENERAL.followers' | translate)}}</span>
</div>
